var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "field-selector" }, [
    _c(
      "div",
      {
        staticClass: "field-item",
        on: {
          click: function ($event) {
            return _vm.selectField("text")
          },
        },
      },
      [
        _c("i", { staticClass: "material-icons" }, [_vm._v("text_fields")]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.$t("tables.text")))]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "field-item",
        on: {
          click: function ($event) {
            return _vm.selectField("long-text")
          },
        },
      },
      [
        _c("i", { staticClass: "material-icons" }, [_vm._v("subject")]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.$t("tables.longText")))]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "field-item",
        on: {
          click: function ($event) {
            return _vm.selectField("number")
          },
        },
      },
      [
        _c("i", { staticClass: "material-icons" }, [_vm._v("looks_one")]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.$t("tables.number")))]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "field-item",
        on: {
          click: function ($event) {
            return _vm.selectField("currency")
          },
        },
      },
      [
        _c("i", { staticClass: "material-icons" }, [_vm._v("attach_money")]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.$t("tables.currency")))]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "field-item",
        on: {
          click: function ($event) {
            return _vm.selectField("datetime")
          },
        },
      },
      [
        _c("i", { staticClass: "material-icons" }, [_vm._v("event")]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.$t("tables.datetime")))]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "field-item",
        on: {
          click: function ($event) {
            return _vm.selectField("dropdown")
          },
        },
      },
      [
        _c("i", { staticClass: "material-icons" }, [_vm._v("arrow_drop_down")]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.$t("tables.dropdown")))]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "field-item",
        on: {
          click: function ($event) {
            return _vm.selectField("checkbox")
          },
        },
      },
      [
        _c("i", { staticClass: "material-icons" }, [_vm._v("check_box")]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.$t("tables.checkbox")))]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "field-item",
        on: {
          click: function ($event) {
            return _vm.selectField("linked-record")
          },
        },
      },
      [
        _c("i", { staticClass: "material-icons" }, [
          _vm._v("switch_access_shortcut"),
        ]),
        _vm._v(" "),
        _c("span", [_vm._v("Linked Record")]),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "divider" }),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "field-item",
        on: {
          click: function ($event) {
            return _vm.selectField("contact")
          },
        },
      },
      [
        _c("i", { staticClass: "material-icons" }, [_vm._v("person")]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.$t("modules.contact")))]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "field-item not-implemented",
        on: {
          click: function ($event) {
            return _vm.selectField("ticket")
          },
        },
      },
      [
        _c("i", { staticClass: "material-icons" }, [
          _vm._v("confirmation_number"),
        ]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.$t("message.ticket")))]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "field-item",
        on: {
          click: function ($event) {
            return _vm.selectField("task")
          },
        },
      },
      [
        _c("i", { staticClass: "material-icons" }, [_vm._v("assignment")]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.$t("message.task")))]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "field-item not-implemented",
        on: {
          click: function ($event) {
            return _vm.selectField("event")
          },
        },
      },
      [
        _c("i", { staticClass: "material-icons" }, [_vm._v("event")]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.$t("message.event")))]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "field-item",
        on: {
          click: function ($event) {
            return _vm.selectField("user")
          },
        },
      },
      [
        _c("i", { staticClass: "material-icons" }, [_vm._v("person")]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.$t("message.user")))]),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "divider" }),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "field-item",
        on: {
          click: function ($event) {
            return _vm.selectField("url")
          },
        },
      },
      [
        _c("i", { staticClass: "material-icons" }, [_vm._v("link")]),
        _vm._v(" "),
        _c("span", [_vm._v("URL")]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "field-item",
        on: {
          click: function ($event) {
            return _vm.selectField("email")
          },
        },
      },
      [
        _c("i", { staticClass: "material-icons" }, [_vm._v("email")]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.$t("tables.email")))]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "field-item",
        on: {
          click: function ($event) {
            return _vm.selectField("phone")
          },
        },
      },
      [
        _c("i", { staticClass: "material-icons" }, [_vm._v("phone")]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.$t("tables.phone")))]),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "divider" }),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "field-item",
        on: {
          click: function ($event) {
            return _vm.selectField("json")
          },
        },
      },
      [
        _c("i", { staticClass: "material-icons" }, [_vm._v("code")]),
        _vm._v(" "),
        _c("span", [_vm._v("JSON")]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "field-item",
        on: {
          click: function ($event) {
            return _vm.selectField("file")
          },
        },
      },
      [
        _c("i", { staticClass: "material-icons" }, [_vm._v("attachment")]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.$t("tables.file")))]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "field-item",
        on: {
          click: function ($event) {
            return _vm.selectField("image")
          },
        },
      },
      [
        _c("i", { staticClass: "material-icons" }, [_vm._v("image")]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.$t("tables.image")))]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "field-item",
        on: {
          click: function ($event) {
            return _vm.selectField("video")
          },
        },
      },
      [
        _c("i", { staticClass: "material-icons" }, [_vm._v("videocam")]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.$t("tables.video")))]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "field-item",
        on: {
          click: function ($event) {
            return _vm.selectField("audio")
          },
        },
      },
      [
        _c("i", { staticClass: "material-icons" }, [_vm._v("audiotrack")]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.$t("tables.audio")))]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "field-item",
        on: {
          click: function ($event) {
            return _vm.selectField("color")
          },
        },
      },
      [
        _c("i", { staticClass: "material-icons" }, [_vm._v("palette")]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.$t("tables.color")))]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "field-item", on: { click: _vm.createAutomationButton } },
      [
        _c("i", { staticClass: "material-icons" }, [_vm._v("smart_button")]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.$t("tables.automationButton")))]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }